import { useEffect, useRef } from 'react';
import { useAgeGate } from './useAgeGate';
import styles from './AgeGateOverlay.module.css';

interface AgeGateOverlayProps {
  /** URL the "Not today" link sends the visitor to. Defaults to Wikipedia. */
  declineHref?: string;
}

/**
 * Full-screen 18+ confirmation overlay. Only the shell renders this.
 * Sub-apps that arrive without confirmation should use `AgeGateRedirect`.
 *
 * Renders nothing when the user has already confirmed.
 */
export function AgeGateOverlay({
  declineHref = 'https://en.wikipedia.org',
}: AgeGateOverlayProps) {
  const { confirmed, confirm } = useAgeGate();
  const confirmButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (confirmed) return;
    confirmButtonRef.current?.focus();
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [confirmed]);

  if (confirmed) return null;

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-gate-title"
      aria-describedby="age-gate-body"
    >
      <div className={styles.card}>
        <div className={styles.ornament} aria-hidden="true">
          ✦
        </div>
        <h1 id="age-gate-title" className={styles.title}>
          before you enter.
        </h1>
        <p id="age-gate-body" className={styles.body}>
          this is a small portfolio of mature interactive pieces that explore
          submission, dynamics, and the practices of the BDSM, kink, and fetish
          community. nothing leaves your browser — there is no tracking, no
          account, no data sent to any server. everything you do here stays in
          your localStorage.
        </p>
        <p className={styles.body}>
          if you are 18 or older and curious, come in.
        </p>
        <div className={styles.actions}>
          <button
            ref={confirmButtonRef}
            type="button"
            className={styles.confirm}
            onClick={confirm}
          >
            i am 18 or older, let me in
          </button>
          <a className={styles.decline} href={declineHref}>
            not today
          </a>
        </div>
      </div>
    </div>
  );
}
